// src/components/Navbar.js
import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux';

import { Select, MenuItem, FormControl, InputBase } from '@mui/material';
import { fontFamily, styled } from '@mui/system';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { setWords } from '../store/reducers/authReducer';
import colors from '../styles/colors';


const CustomSelect = styled(Select)(({ theme }) => ({
    border: '0px solid #007FFF', // Blue border
    // padding: '5px 10px',
    display: 'flex',
    fontSize: 14,
    fontFamily: 'PRe',
    // alignItems: 'center',
    '& .MuiSelect-icon': {
        color: 'green', // Custom icon color
    },
    '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
    },
}));


const Navbar = ({ toggleSidebar, sidebarOpen }) => {

    const lang = useSelector((state) => state.authReducer.lang);
    const words = useSelector((state) => state.authReducer.words);
    const [language, setLanguage] = useState('English');
    const dispatch = useDispatch();

    const handleChange = (event) => {

        if (event.target.value == 'Arabic') {
            dispatch(setWords("ar"));
            return;
        }
        dispatch(setWords("en"))


    };



    return (
        <AppBar
            position="fixed"
            elevation={0}
            sx={{
                width: sidebarOpen ? `calc(100% - 240px)` : '100%',
                backgroundColor: colors.bg,
                marginLeft: lang == 'ar' ? 0 : sidebarOpen ? '240px' : '0',
                marginRight: lang == 'en' ? 0 : sidebarOpen ? '240px' : '0',
                transition: 'width 0.3s ease',
            }}
        >
            <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>

                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        onClick={toggleSidebar}
                        sx={{ color: 'black', ml: lang == 'ar' ? 2 : 0, }}
                    //  mr: lang == 'ar' ? 2 : 0, 
                    >
                        <MenuIcon />
                    </IconButton>

                    <Typography sx={{ color: colors.navbarScreenHeading, fontFamily: 'IBo', fontSize: 26, ml: 2 }} >Dashboard</Typography>
                </Box>
                <Box>
                    <FormControl fullWidth variant="outlined">
                        <CustomSelect
                            value={lang == 'en' ? 'English' : 'Arabic'}
                            onChange={handleChange}
                            IconComponent={ArrowDropDownIcon}
                        >
                            <MenuItem style={{ fontFamily: 'PRe', fontSize: 12 }} value="English">{words["English"]}</MenuItem>
                            <MenuItem style={{ fontFamily: 'PRe', fontSize: 12 }} value="Arabic">{words["Arabic"]}</MenuItem>
                        </CustomSelect>
                    </FormControl>
                </Box>

            </Toolbar>





        </AppBar>
    );
};

export default Navbar;
